import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  production: true,
  theme: 'superstars',
  apiUrl: 'http://127.0.0.1:8500',
  language: 'en',
};
